import { MeetingUnit } from 'modules/calendar/constants/calendarMeetingTemplateSchema';

export const convertTimeUnitValuesToMinutes = (
  value: number,
  unit: MeetingUnit
) => {
  switch (unit) {
    case MeetingUnit.Minutes:
      return value;
    case MeetingUnit.Hours:
      return value * 60;
    case MeetingUnit.Days:
      return value * 60 * 24;
    default:
      return 0;
  }
};
